import { render, staticRenderFns } from "./UnpCell.vue?vue&type=template&id=720fc808&scoped=true"
import script from "./UnpCell.vue?vue&type=script&lang=js"
export * from "./UnpCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720fc808",
  null
  
)

export default component.exports